import { render } from "./UiDynamischeTabellePerioden.pug?vue&type=template&id=9d0bc2e4&lang=pug"
import script from "./UiDynamischeTabellePerioden.js?vue&type=script&lang=js"
export * from "./UiDynamischeTabellePerioden.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__